import { Link } from 'react-router-dom';
import { publicHref } from '../lib/publicUrls';
import { PHOTO_ASSETS } from '../data/photoAssets';
import MediaTruthSurface from './MediaTruthSurface';
import './ServiceHeader.css';

// Shared service-page header pieces (owner direction, Sept 29): a breadcrumb trail in place of
// the back arrow, and a strip of short facts drawn only from each page's existing wording.
export const ServiceBreadcrumb = ({ parent = { label: 'Programs', href: '/programs' }, current }) => (
  <nav className="dv-service-breadcrumb" aria-label="Breadcrumb">
    <ol>
      <li><Link to={publicHref(parent.href)}>{parent.label}</Link></li>
      <li aria-current="page">{current}</li>
    </ol>
  </nav>
);

export const ServiceFacts = ({ items, className = '' }) => (
  <ul className={`dv-service-facts ${className}`.trim()} aria-label="At a glance">
    {items.map((item) => <li key={item}>{item}</li>)}
  </ul>
);

// Program header in the Kids & Family layout (owner direction, Sept 30): the program's photo fills
// the header behind its haze, and the breadcrumb, title, introduction and buttons sit on the left
// in a translucent panel, with the facts strip along the bottom. Without an approved photo the
// header stays dark with the program's haze. Pages may pass `disclosure` to record internal media
// review status; it is never shown to visitors.
export const ServiceHero = ({ id, media, mark, parent, current, title, label, lede, actions, facts, haze, className = '' }) => {
  const hasPhoto = Boolean(PHOTO_ASSETS[media.id]);
  return (
    <section className={`dv-service-hero ${className}`.trim()} aria-labelledby={id} style={haze ? { '--dv-haze': haze } : undefined}>
      {hasPhoto && <MediaTruthSurface media={media} className="dv-service-hero__media" />}
      <div className="dv-service-hero__copy">
        <div className="dv-service-panel">
          {mark}
          <ServiceBreadcrumb parent={parent} current={current} />
          <h1 id={id} className="dv-size-heading dv-service-title dv-service-hero__title" aria-label={label}>{title}</h1>
          <p className="dv-size-lede dv-service-hero__lede">{lede}</p>
          <div className="dv-service-actions">{actions}</div>
        </div>
      </div>
      <ServiceFacts items={facts} />
    </section>
  );
};
